"use strict";

var _jsxRuntime = require("react/jsx-runtime");

module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", { ...props,
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M10.086 14.325a.3.3 0 0 0 .122.023l2.281-.001c.177 0 .318-.144.338-.32.12-1.03.818-1.69 1.527-2.363l.002-.001C15.17 10.892 16 10.105 16 8.73 16 6.835 13.865 6 12.067 6 9.82 6 8 6.991 8 8.817c0 .141.007.282.019.423a.317.317 0 0 0 .318.291h2.216c.209 0 .369-.2.368-.41v-.042c0-.731.562-1.01 1.056-1.01.495 0 1.102.279 1.102.94 0 .803-.63 1.39-1.329 2.04l-.004.005c-.814.757-1.721 1.601-1.844 2.974a.3.3 0 0 0 .184.297Zm-.001 3.651a.32.32 0 0 0 .123.024h2.281a.32.32 0 0 0 .32-.32v-1.62a.32.32 0 0 0-.32-.32h-2.281a.32.32 0 0 0-.32.32v1.62a.32.32 0 0 0 .197.296Z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Zm0-2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z",
    clipRule: "evenodd"
  })]
});